import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormikProps } from 'formik';
import { FinalCausality } from '../../../../shared/types/typifications/finalCausality';
import {
    FINAL_CAUSALITY,
    FINAL_CAUSALITY_DETAIL,
} from '../../../../routes/paths';
import {
    asyncCreateFinalCausality,
    asyncUpdateFinalCausality,
} from '../../../../services/finalCausality.service';
import { ToastSwal } from '../../../components/general/toastSwals/toastSwal';
import { asyncGetParam } from '../../../../services/param.service';
import { IParams } from '../../../../shared/types/redirectParams';

export const useFinalCausalityForm = () => {
    const navigate = useNavigate();
    const { idFinalCausality } = useParams();
    const [finalCausality, setFinalCausality] = useState<IParams>();
    const [loading, setLoading] = useState(false);
    const [formikFinalCausalityData, setFormikFinalCausalityData] =
        useState<FormikProps<FinalCausality>>();

    const isValidForm = formikFinalCausalityData?.isValid;

    const handleCleanAndBack = () => {
        formikFinalCausalityData?.resetForm();
        navigate(FINAL_CAUSALITY);
    };

    const handleSubmit = async () => {
        await formikFinalCausalityData?.submitForm();

        if (!isValidForm) return;

        setLoading(true);

        const data: FinalCausality =
            formikFinalCausalityData?.values as FinalCausality;

        let res: any | undefined = undefined;

        try {
            if (finalCausality && finalCausality.id)
                res = await asyncUpdateFinalCausality(finalCausality.id, data);
            else res = await asyncCreateFinalCausality(data);
        } catch (error) {}

        if (res) {
            ToastSwal.fire({
                text: `¡Felicidades! La redirección se ${
                    finalCausality && finalCausality.id ? 'actualizo' : 'creó'
                } satisfactoriamente.`,
                icon: 'success',
                timer: 5000,
                position: 'center-end',
            });
            navigate(`${FINAL_CAUSALITY_DETAIL}/${res?.id}`);
        } else {
            ToastSwal.fire({
                text: `Lo sentimos, no se pudo ${
                    finalCausality && finalCausality.id ? 'actualizar' : 'crear'
                } la redirección. Por favor, asegúrate de ${
                    finalCausality && finalCausality.id
                        ? 'diligenciar los datos correctamente'
                        : 'que no exista previamente'
                } e intenta nuevamente más tarde.`,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }

        setLoading(false);
    };

    useEffect(() => {
        if (Boolean(idFinalCausality?.trim())) {
            setLoading(true);
            asyncGetParam(idFinalCausality?.trim())
                .then((finalCausality: any) => {
                    if (!finalCausality || !finalCausality.items)
                        navigate(FINAL_CAUSALITY);
                    setFinalCausality(finalCausality?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [idFinalCausality]);

    return {
        finalCausality,
        loading,
        isValidForm,
        handleSubmit,
        handleCleanAndBack,
        setFormikFinalCausalityData,
    };
};
